import React from 'react';
import { useTranslation } from 'react-i18next';
import Alert from 'components/Alert';

const NETWORK_NAMES: Record<string, string> = {
  facebook: 'Facebook',
  twitter: 'X',
  linkedin: 'LinkedIn',
  instagram: 'Instagram',
  tiktok: 'TikTok'
};

interface InvalidTokenBannerProps {
  networks: string[];
  onConnect: (network: string) => void;
  onClose: () => void;
}

// Un solo aviso con una línea por red: el Alert es `position: fixed`, así que
// varios se encimarían. No se cierra solo; la X lo oculta hasta que recargue.
const InvalidTokenBanner: React.FC<InvalidTokenBannerProps> = props => {
  const { networks, onConnect, onClose } = props;
  const { t } = useTranslation(['social_network']);

  if (networks.length === 0) return null;

  return (
    <Alert type="error" allowClose={true} autoClose={false} onClose={onClose}>
      <div>
        {networks.map(network => (
          <p key={network} style={{ margin: '4px 0' }}>
            {`${t('social_network:token_permissions', {
              invalidToken: NETWORK_NAMES[network] ?? network
            })}, ${t('social_network:update_permissions')}`}
            <a style={{ cursor: 'pointer' }} onClick={() => onConnect(network)}>
              {t('social_network:here')}
            </a>
          </p>
        ))}
      </div>
    </Alert>
  );
};

export default InvalidTokenBanner;
